// src/ctxReflector/components/Instances/views/Licensed/HealthCheckPage.tsx
import React, { useState, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { GenericTable } from "@ui-components/Table/GenericTable"
import GenericButton from "@ui-components/Button/GenericButton"
import { GenericFilter } from "@ui-components/Filter/GenericFilter"
import { useProcessingOverlay } from "@hooks/useProcessingOverlay"
import { fetchHealthCheck } from "./request/request"
import { HealthCheckItem, columns } from "./HealthCheckData"

function HealthCheckPage() {
    const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0()
    const [items, setItems] = useState<HealthCheckItem[]>([])
    const [isFetching, setIsFetching] = useState(false)
    const [searchTerm, setSearchTerm] = useState("")
    const [searchColumn, setSearchColumn] = useState("All")
    const searchOptions = ["All", "Name", "Status"]
    const overlay = useProcessingOverlay(isFetching)

    useEffect(() => {
        if (isLoading || !isAuthenticated) return
        loadData()
    }, [isLoading, isAuthenticated])

    const loadData = async () => {
        try {
            setIsFetching(true)
            const token = await getAccessTokenSilently()
            const resp = await fetchHealthCheck(token)
            setItems(resp.data.data || [])
        } finally {
            setIsFetching(false)
        }
    }

    const handleRefresh = () => {
        loadData()
    }

    const filteredData = items.filter((row) => {
        const term = searchTerm.toLowerCase().trim()
        if (!term) return true
        const includes = (val: string) => val.toLowerCase().includes(term)
        if (searchColumn === "Name") return includes(row.name)
        if (searchColumn === "Status") return row.mainStatus ? includes(row.mainStatus) : false
        return includes(row.name) || (row.mainStatus ? includes(row.mainStatus) : false)
    })

    return (
        <div className="relative p-4">
            <div className="flex items-center justify-end mb-4 gap-2">
                <GenericFilter
                    searchTerm={searchTerm}
                    onSearchTermChange={setSearchTerm}
                    searchColumn={searchColumn}
                    onSearchColumnChange={setSearchColumn}
                    columnOptions={searchOptions}
                />
                <GenericButton label="Refresh" variant="secondary" onClick={handleRefresh} />
            </div>
            <GenericTable
                columns={columns}
                data={filteredData}
                initialRowsPerPage={5}
                rowsPerPageOptions={[5, 10, 20]}
                width="100%"
                tableClassName="bg-semantic-bg-primary"
            />
            {overlay}
        </div>
    )
}

export default HealthCheckPage
